import { createModel } from "@/util/ModelUtil";
import UserModel from "@/service/model/user/UserModel";
import LectureModel from "@/service/model/lecture/LectureModel";
import MyLectureModel from "@/service/model/myLecture/MyLectureModel";

export default class LectureProgressRateByUserDataModel {
  constructor(
    public lecture: Lecture = new LectureModel(),
    public user: User = new UserModel(),
    public myLecture: MyLecture = new MyLectureModel(),
    public inflearnVoucher?: InfLearnVoucherData
  ) {}

  public static create(
    lectureProgressRateByUserData?: LectureProgressRateByUserData
  ): LectureProgressRateByUserDataModel {
    return createModel<LectureProgressRateByUserDataModel>(
      LectureProgressRateByUserDataModel,
      lectureProgressRateByUserData
    );
  }
}
